export default "__VITE_PUBLIC_ASSET__7031ea0d__"